import { ToastProvider } from './components/ui/Toast'
import { ConfirmProvider } from './components/ui/ConfirmDialog'
import { AnimatedPageWrapper } from './components/ui/AnimatedPageWrapper'
import styles from './AppShell.module.css'

/**
 * AppShell envuelve TODAS las rutas (incluyendo las de usuario final como
 * el tótem `/screens`, galería pública `/galerias/:c/:t`, etc). Por eso NO
 * se monta acá nada que el invitado no deba ver — el `<HealthBadge>` (que
 * muestra el estado del backend) vive en `ConsoleLayout` y `LoginRoute`,
 * que son las superficies de operador.
 */
export function AppShell() {
  return (
    <ToastProvider>
      <ConfirmProvider>
        <div className={styles.shell}>
          <AnimatedPageWrapper />
        </div>
      </ConfirmProvider>
    </ToastProvider>
  )
}
